function loadingReducer(state = {
    loading:false,
}, action) {
  switch (action.type) {
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.loading,
      };
    default:
      return state;
  }
} // Редюсер который отвечает за отображение спиннера

export default loadingReducer 





// WEBPACK FOOTER //
// src/reducers/loadingReducer.js